import React from "react";

export default function () {
    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.6)",
        }}>
            {/* Bouncing dots animation */}
            <div style={{
                display: "flex",
                gap: 8,
                alignItems: "flex-end",
                height: 60,
            }}>
                <span style={{
                    display: "inline-block",
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    background: "#0d6efd",
                    animation: "bounce 1s infinite",
                    animationDelay: "0s"
                }} />
                <span style={{
                    display: "inline-block",
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    background: "#0d6efd",
                    animation: "bounce 1s infinite",
                    animationDelay: "0.2s"
                }} />
                <span style={{
                    display: "inline-block",
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    background: "#0d6efd",
                    animation: "bounce 1s infinite",
                    animationDelay: "0.4s"
                }} />
            </div>
            <div style={{ marginTop: 16, fontSize: 18, color: "#333" }}>Đang tải...</div>
            <style>
                {`
                @keyframes bounce {
                    0%, 80%, 100% {
                        transform: translateY(0);
                    }
                    40% {
                        transform: translateY(-20px);
                    }
                }
                `}
            </style>
        </div>
    );
}